import { render } from "./ProjectGeneralData.vue?vue&type=template&id=2a393d3f&scoped=true"
import script from "./ProjectGeneralData.vue?vue&type=script&lang=js"
export * from "./ProjectGeneralData.vue?vue&type=script&lang=js"

import "./ProjectGeneralData.vue?vue&type=style&index=0&id=2a393d3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a393d3f"],['__file',"src/components/project/ProjectGeneralData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a393d3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a393d3f', __exports__)) {
    api.reload('2a393d3f', __exports__)
  }
  
  module.hot.accept("./ProjectGeneralData.vue?vue&type=template&id=2a393d3f&scoped=true", () => {
    api.rerender('2a393d3f', render)
  })

}


export default __exports__